<template>
  <b v-if="item">{{tday}} дней [ {{thour}} : {{tmin}} : {{tsec}} ]</b>
</template>

<script>
export default {
  data: () => ({
    tday: "00",
    thour: "00",
    tmin: "00",
    tsec: "00",
          today: ''
  }),
  name: "Timer",
  props: ["item"],
  methods: {
 
    timeInterval() {

      if (this.item && this.item.end_date) {
      
        let dateBefore = this.item.end_date;

        let a = dateBefore.split(" ");
  
        let d = a[0].split("-");

        let t = a[1].split(":");

        let timeend = this.item.end_date;

        this.today = Math.round(new Date().getTime());

        this.today = Math.floor((timeend - this.today) / 1000);

        this.tsec = this.today % 60;

        this.today = Math.floor(this.today / 60);

        if (this.tsec < 10  && this.tsec>-1) this.tsec = "0" + this.tsec;

        this.tmin = this.today % 60;

        this.today = Math.floor(this.today / 60);

        if (this.tmin < 10 && this.tmin>-1) this.tmin = "0" + this.tmin;

        this.thour = this.today % 24;

        this.tday = Math.ceil (this.today / 24);

        if (this.thour < 10 && this.thour>-1) this.thour = "0" + this.thour;

        if (this.thour<0){
            this.thour = '00';
        }
        if (this.tmin<0){
            this.tmin = '00';
        }
        if (this.tsec<0){
            this.tsec = '00';
        }

        this.today = Math.floor(this.today / 24);

        window.setTimeout(() => {
          this.timeInterval();
        }, 1000);
      }
    },

  },
  created() {
    this.timeInterval();
  }
};
</script>